import { getFallbackValueIfNull } from 'owa-options-core';
import {
    getOptionsForFeature,
    GdprAdsV2Options,
    OwsOptionsFeatureType,
} from 'owa-outlook-service-options';
import getStore from '../store/getStore';

export default function getOptions() {
    const savedOptions = getOptionsForFeature<GdprAdsV2Options>(OwsOptionsFeatureType.GdprAdsV2);

    const options = getStore();

    let currentDisselectedVendorId = [];
    if (options.disselectedVendorId && options.disselectedVendorId.length > 0) {
        currentDisselectedVendorId = options.disselectedVendorId;
    } else if (savedOptions.disselectedVendorId && savedOptions.disselectedVendorId.length > 0) {
        currentDisselectedVendorId = savedOptions.disselectedVendorId;
    }

    return {
        allowAccess: getFallbackValueIfNull(
            options.allowAccess,
            savedOptions.consentString ? savedOptions.allowStorageAndAccess : true
        ),

        allowAdSelection: getFallbackValueIfNull(
            options.allowAdSelection,
            savedOptions.consentString ? savedOptions.allowAdSelectionDeliveryReporting : true
        ),

        allowContentSelection: getFallbackValueIfNull(
            options.allowContentSelection,
            savedOptions.consentString ? savedOptions.allowContentSelectionDeliveryReporting : true
        ),

        allowPersonalization: getFallbackValueIfNull(
            options.allowPersonalization,
            savedOptions.consentString ? savedOptions.allowPersonalization : true
        ),

        allowMeasurement: getFallbackValueIfNull(
            options.allowMeasurement,
            savedOptions.consentString ? savedOptions.allowMeasurement : true
        ),

        disselectedVendorId: currentDisselectedVendorId,
    };
}
